import React from 'react';

const typeLabel = {
  recharge: 'Recharge',
  consultation_debit: 'Consultation',
  consultation_credit: 'Earnings',
  withdrawal: 'Withdrawal',
  refund: 'Refund',
  promo_credit: 'Promo',
};

const typeColor = {
  recharge: '#00b894',
  consultation_debit: '#d63031',
  consultation_credit: '#00b894',
  withdrawal: '#e17055',
  refund: '#0984e3',
  promo_credit: '#6c5ce7',
};

const TransactionItem = ({ txn }) => {
  const isCredit = txn.direction === 'credit';
  const label = typeLabel[txn.type] || txn.type;
  const color = typeColor[txn.type] || '#636e72';
  const sign = isCredit ? '+' : '-';
  const amount = typeof txn.amount === 'number' ? txn.amount.toFixed(2) : txn.amount;
  const date = txn.created_at
    ? new Date(txn.created_at).toLocaleDateString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : '';

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '12px 0',
        borderBottom: '1px solid #f0f0f0',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div
          style={{
            width: 36,
            height: 36,
            borderRadius: '50%',
            background: color + '20',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color,
            fontWeight: 700,
            fontSize: 16,
          }}
        >
          {sign}
        </div>
        <div>
          <div style={{ fontWeight: 600, fontSize: 14 }}>{label}</div>
          <div style={{ fontSize: 12, color: '#636e72' }}>{txn.description || ''}</div>
          <div style={{ fontSize: 11, color: '#b2bec3' }}>{date}</div>
        </div>
      </div>
      <div style={{ textAlign: 'right' }}>
        <div style={{ fontWeight: 700, color, fontSize: 15 }}>
          {sign}₹{amount}
        </div>
        <div style={{ fontSize: 11, color: '#b2bec3', textTransform: 'capitalize' }}>
          {txn.status}
        </div>
      </div>
    </div>
  );
};

export default TransactionItem;
